import * as React from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import './BuildingDetails.css';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableListItem from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableListItem';

class ThatchRoof extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            noneOfTheAbove: false,
            submitted: false,
            nextDisabled: false,
            buildingAdditionalDetail: this.props.sales.buildingAdditionalDetail ?? { thatch_lightningConductor: false, thatch_fireExtinguisher: false, thatch_fireRetardantTreatment: false, thatch_harveyTiles: false, thatch_distanceBetween: null},
        };

        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);
    }

    componentDidMount() {
        this.checkSubmit();
    }

    checkSubmit() {
        let valid = true;
        if (this.props.sales.buildingAdditional.thatchRoof) {
            valid = (this.state.buildingAdditionalDetail?.thatch_lightningConductor ||
                this.state.buildingAdditionalDetail?.thatch_fireExtinguisher ||
                this.state.buildingAdditionalDetail?.thatch_fireRetardantTreatment ||
                this.state.buildingAdditionalDetail?.thatch_harveyTiles ||
                this.state.noneOfTheAbove);
        }

        if (this.props.sales.buildingAdditional.thatchLapa) {
            valid = valid ? (this.state.buildingAdditionalDetail.thatch_distanceBetween !== null) : false;
        }

        this.setState({ nextDisabled: !valid });
    }

    handleChangeValue(e: any) {
        let value = e.target.value !== "" ? Number(e.target.value) : null;
        this.setState({ buildingAdditionalDetail: { ...this.state.buildingAdditionalDetail, thatch_distanceBetween: value } },
            () => { this.checkSubmit() }
        );
    }

    handleItemSelect(id: string, selected: boolean) {
        let name = id.slice(3);
        name = name.charAt(0).toLowerCase() + name.slice(1);

        if (name !== "noneOfTheAbove") {
            this.setState({
                noneOfTheAbove: false,
                buildingAdditionalDetail: { ...this.state.buildingAdditionalDetail, [name]: selected }
            }, () => this.checkSubmit());
        }
        else {
            this.setState({
                noneOfTheAbove: selected,
                buildingAdditionalDetail: { ...this.state.buildingAdditionalDetail, thatch_lightningConductor: false, thatch_fireExtinguisher: false, thatch_fireRetardantTreatment: false, thatch_harveyTiles: false }
            }, () => this.checkSubmit());
        }
    }

    handleNextStep() {
        if (!this.state.nextDisabled) {
            let buildingAdditionalDetail = {
                ...this.props.sales.buildingAdditionalDetail,
                thatch_lightningConductor: this.state.buildingAdditionalDetail.thatch_lightningConductor,
                thatch_fireExtinguisher: this.state.buildingAdditionalDetail.thatch_fireExtinguisher,
                thatch_fireRetardantTreatment: this.state.buildingAdditionalDetail.thatch_fireRetardantTreatment,
                thatch_harveyTiles: this.state.buildingAdditionalDetail.thatch_harveyTiles,
                thatch_distanceBetween: this.state.buildingAdditionalDetail.thatch_distanceBetween,
            };
            this.props.dispatchAction(setQuoteData({ buildingAdditionalDetail, requiresReferral: false }));
            this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        return (
            <div className="container">
                {this.props.sales.buildingAdditional.thatchRoof &&
                    <>
                        <div className="text-center">
                            Which of these treatment measures are in place for your thatch roof?
                        </div>

                        <div className="row mt-4 mb-4">
                            <div className="mb-4 col-md-8 offset-md-2" style={{ textAlign: "left" }}>
                                <div className="ssp-selectable-list  ssp-selectable-list-autosize property-info text-left">
                                    <KPSelectableListItem
                                        id="chkThatch_lightningConductor"
                                        label="Lightning conductor"
                                        value="thatch_lightningConductor"
                                        selected={this.state.buildingAdditionalDetail.thatch_lightningConductor}
                                        className="checkboxGroup"
                                        handleSelect={this.handleItemSelect}
                                    />
                                    {/*<KPSelectableListItem*/}
                                    {/*    id="chkThatch_fireExtinguisher"*/}
                                    {/*    label="Fire Extinguisher"*/}
                                    {/*    value="thatch_fireExtinguisher"*/}
                                    {/*    selected={this.state.buildingAdditionalDetail.thatch_fireExtinguisher}*/}
                                    {/*    className="checkboxGroup"*/}
                                    {/*    handleSelect={this.handleItemSelect}*/}
                                    {/*/>*/}
                                    <KPSelectableListItem
                                        id="chkThatch_fireRetardantTreatment"
                                        label="Fire Retardant Treatment"
                                        value="thatch_fireRetardantTreatment"
                                        selected={this.state.buildingAdditionalDetail.thatch_fireRetardantTreatment}
                                        className="checkboxGroup"
                                        handleSelect={this.handleItemSelect}
                                    />
                                    {/*<KPSelectableListItem*/}
                                    {/*    id="chkThatch_harveyTiles"*/}
                                    {/*    label="Harvey tiles"*/}
                                    {/*    value="thatch_harveyTiles"*/}
                                    {/*    selected={this.state.buildingAdditionalDetail.thatch_harveyTiles}*/}
                                    {/*    className="checkboxGroup"*/}
                                    {/*    handleSelect={this.handleItemSelect}*/}
                                    {/*/>*/}
                                    <KPSelectableListItem
                                        id="chkNoneOfTheAbove"
                                        label="None of the above"
                                        value="noneOfTheAbove"
                                        selected={this.state.noneOfTheAbove}
                                        className="checkboxGroup"
                                        handleSelect={this.handleItemSelect}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }

                {this.props.sales.buildingAdditional.thatchLapa &&
                    <div className={"text-center" + (this.props.sales.buildingAdditional.thatchRoof ? " mt-5" : "")}>
                        How far is the building from the thatch lapa in meters?
                        <br/>
                        <div className="ssp-inputtextarea-input-element-container mt-4 mb-4">
                            <div className={"form-group noma" + (this.state.submitted && (this.state.buildingAdditionalDetail.thatch_distanceBetween === null) ? " has-error" : '')}>
                                <div>
                                    <span className="unit-label">m</span>
                                    <NumberFormat
                                        id={"txtThatchDistanceBetween" + this.props.id}
                                        name={"txtThatchDistanceBetween" + this.props.id}
                                        placeholder="0"
                                        thousandSeparator={false}
                                        thousandsGroupStyle="thousand"
                                        prefix=""
                                        value={this.state.buildingAdditionalDetail.thatch_distanceBetween ?? ""}
                                        required={true}
                                        className="ssp-inputtextarea-input-element"
                                        onChange={e => this.handleChangeValue(e)}
                                    />
                                </div>
                                {this.state.submitted && (this.state.buildingAdditionalDetail.thatch_distanceBetween === null) &&
                                    <div className="form-inline-error">Distance is required</div>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div className="row">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThatchRoof);